import React, { useState, useContext, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { ReportsFragmentContext } from "../../../../ReportFragment.jsx";

const CourseStudentAnalyticsMetaSelection = () => {

    //@ts-ignore
    const { viewHandler, setViewHandler, companies, courseStudentAnalyticsFormData, setCourseStudentAnalyticsFormData } = useContext(ReportsFragmentContext);
    const [courses, setCourses] = useState<string[]>([]);
    const token = localStorage.getItem("token") || "";

    const fetchCourses = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const requestOptions: any = { method: "GET", headers: myHeaders, redirect: "follow" };
        fetch(`https://beiguru.co.in/admin/courses-company/${courseStudentAnalyticsFormData?.company}`, requestOptions).then(async (response: any) => {
            if (response.status == 401) { localStorage.clear(); window.location.reload(); }
            else { const data = await response.json(); setCourses(data); }
        }).catch((error) => console.error(error));
    }

    useEffect(() => {
        fetchCourses();
    }, [courseStudentAnalyticsFormData?.company])

    return (
        <React.Fragment>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'space-between' }}>
                <h4 style={{ color: 'black' }}>Course Analytics</h4>
                <Button
                    variant='outline-primary'
                    style={{ fontWeight: '600', borderRadius: '5px', marginLeft: '10px' }}
                    onClick={() => setViewHandler(prevState => ({ ...prevState, view: 'dashboard-analytics' }))}
                >
                    Back
                </Button>
            </div>

            <div style={{ width: '33vw', margin: '5rem auto 0 auto', textAlign: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', rowGap: '1rem' }}>
                    <Form.Group controlId="formCompany" style={{ marginLeft: '10px' }}>
                        <h6 style={{ textAlign: 'left' }}>School</h6>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Form.Control
                                as="select"
                                value={courseStudentAnalyticsFormData.company}
                                onChange={(e) => { setCourseStudentAnalyticsFormData(prevState => ({ ...prevState, company: e.target.value })) }}
                                disabled={!!courseStudentAnalyticsFormData.company}
                                style={{ flex: 1 }}
                            >
                                <option value="">Select school</option>
                                {companies.map(company => (<option key={company._id} value={company._id}>{company.name}</option>))}
                            </Form.Control>
                            {courseStudentAnalyticsFormData.company && (
                                <Button variant="outline-secondary" onClick={() => setCourseStudentAnalyticsFormData(prevState => ({ ...prevState, company: "", course: "" }))}>
                                    Re-select
                                </Button>
                            )}
                        </div>
                    </Form.Group>

                    <Form.Group controlId="formCourse" style={{ marginLeft: '10px' }}>
                        <h6 style={{ textAlign: 'left' }}>Course</h6>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Form.Control
                                as="select"
                                value={courseStudentAnalyticsFormData.course}
                                onChange={(e) => { setCourseStudentAnalyticsFormData(prevState => ({ ...prevState, course: e.target.value })); }}
                                disabled={!!courseStudentAnalyticsFormData.course}
                                style={{ flex: 1 }}
                            >
                                <option value="">Select the course</option>
                                {courses.map((course: any) => (
                                    <option key={course._id} value={course._id}>{course.title}</option>
                                ))}
                            </Form.Control>

                            {courseStudentAnalyticsFormData.course && (
                                <Button variant="outline-secondary" onClick={() => setCourseStudentAnalyticsFormData(prevState => ({ ...prevState, course: "" }))} >
                                    Re-select
                                </Button>
                            )}
                        </div>
                    </Form.Group>

                    <Button
                        disabled={Object.values(courseStudentAnalyticsFormData).some(value => !value)}
                        variant='outline-primary'
                        style={{ fontWeight: '600', borderRadius: '5px', marginLeft: '10px', marginTop: '1rem' }}
                        onClick={() => setViewHandler(prevState => ({ ...prevState, subView: 'course-student-analytics' }))}>
                        View Analytics
                    </Button>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CourseStudentAnalyticsMetaSelection;